function UMD(module, imports) {
  return function (root, factory) {
    exported = factory.apply(this, Object.keys(imports).map(function(m){
      if (typeof imports[m] == 'string') return root[imports[m]];
      return imports[m].reduce(function(all, v){
        all[v] = root[v]; return all; }, {}); }));
    Object.keys(exported).map(function(e){ root[e] = exported[e]; });
  };
}

UMD.require = function(module_name) {
  return window;
};
